import { render, staticRenderFns } from "./dashboard-layout.vue?vue&type=template&id=6f228495&scoped=true"
import script from "./dashboard-layout.vue?vue&type=script&lang=js"
export * from "./dashboard-layout.vue?vue&type=script&lang=js"
import style0 from "./dashboard-layout.vue?vue&type=style&index=0&id=6f228495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f228495",
  null
  
)

export default component.exports